export default __webpack_public_path__ + "static/media/Brownie.c9d08342.gif";